import { Nullable } from "./Nullable";

export function apiUrl(path: string) {
  return `${process.env.REACT_APP_API_GATEWAY_URL}${path}`;
}

export function getApiHeaders(accessToken: Nullable<string>) {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
}
